import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, Clock } from 'lucide-react';

const AGB = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2 flex items-center">
            <FileText className="w-10 h-10 mr-3 text-emerald-600" />
            AGB & Widerrufsrecht
          </h1>
          <p className="text-gray-600">Allgemeine Geschäftsbedingungen für INTERLINGUA.APP</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 prose max-w-none">
          
          <div className="bg-emerald-50 p-4 rounded-lg mb-8">
            <p className="text-emerald-800 font-medium mb-2">📋 Wichtige Information</p>
            <p className="text-emerald-700 text-sm">
              Diese AGB gelten für die Nutzung von INTERLINGUA.APP, einer KI-gestützten Sprachlern-Plattform 
              der MYSYMP AG. Bitte lesen Sie diese Bedingungen sorgfältig durch.
            </p>
          </div>

          <h2>1. Geltungsbereich und Vertragspartner</h2>
          <p>
            <strong>Vertragspartner:</strong> MYSYMP AG, CH-6207 Nottwil, Schweiz<br />
            <strong>Kontakt:</strong> info@interlingua.app
          </p>
          <p>
            Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Leistungen der 
            INTERLINGUA.APP-Plattform und regeln das Vertragsverhältnis zwischen der MYSYMP AG 
            und den Nutzern.
          </p>

          <h2>2. Leistungsbeschreibung</h2>
          <h3>2.1 INTERLINGUA.APP-Dienste</h3>
          <ul>
            <li><strong>KI-gestützte Sprachkonversationen</strong> mit personalisierten virtuellen Lehrern</li>
            <li><strong>Aussprache-Training</strong> mit KI-basiertem Feedback</li>
            <li><strong>Mehrsprachige Unterstützung:</strong> Englisch, Französisch, Spanisch, Italienisch</li>
            <li><strong>Personalisierte Lernpfade</strong> basierend auf individuellem Fortschritt</li>
            <li><strong>Spracherkennung und Text-to-Speech</strong> Funktionen</li>
          </ul>

          <h3>2.2 Freemium-Modell</h3>
          <ul>
            <li><strong>Kostenlose Basis-Version</strong> mit eingeschränktem Funktionsumfang</li>
            <li><strong>Premium-Abonnement:</strong> CHF 10/Monat oder CHF 100/Jahr</li>
            <li><strong>Zusätzliche Premium-Features:</strong> Unbegrenzte Konversationen, erweiterte Analytics, prioritärer Support</li>
          </ul>

          <h2>3. Vertragsschluss und Registrierung</h2>
          <h3>3.1 Registrierung</h3>
          <p>
            Zur Nutzung von INTERLINGUA.APP ist eine Registrierung erforderlich. Bei der Registrierung 
            müssen wahrheitsgemäße Angaben gemacht werden:
          </p>
          <ul>
            <li>Name und E-Mail-Adresse</li>
            <li>Muttersprache und gewünschte Lernsprachen</li>
            <li>Aktuelles Sprachniveau</li>
          </ul>

          <h3>3.2 Vertragsschluss</h3>
          <p>
            Der Vertrag kommt durch die Bestätigung Ihrer Registrierung zustande. 
            Bei Premium-Abonnements erfolgt der Vertragsschluss mit der Zahlungsbestätigung.
          </p>

          <h2>4. Preise und Zahlungsbedingungen</h2>
          <h3>4.1 Kostenlose Nutzung</h3>
          <p>
            Die Basis-Version von INTERLINGUA.APP ist kostenlos und umfasst grundlegende 
            Sprachlern-Funktionen mit begrenztem Nutzungsumfang.
          </p>

          <h3>4.2 Premium-Abonnement</h3>
          <ul>
            <li><strong>Monatliches Abo:</strong> CHF 10,00 pro Monat</li>
            <li><strong>Jahresabo:</strong> CHF 100,00 pro Jahr (entspricht CHF 8,33/Monat)</li>
            <li>Alle Preise verstehen sich inklusive der gesetzlich gültigen Mehrwertsteuer</li>
          </ul>

          <h3>4.3 Zahlungsmodalitäten</h3>
          <ul>
            <li>Zahlung per Kreditkarte, PayPal oder Banküberweisung</li>
            <li>Bei Monatsabos: monatliche Abbuchung zum Buchungsdatum</li>
            <li>Bei Jahresabos: jährliche Abbuchung zum Buchungsdatum</li>
          </ul>

          <h2>5. Laufzeit und Kündigung</h2>
          <h3>5.1 Laufzeit</h3>
          <ul>
            <li><strong>Monatsabo:</strong> 1 Monat, verlängert sich automatisch um jeweils 1 Monat</li>
            <li><strong>Jahresabo:</strong> 12 Monate, verlängert sich automatisch um jeweils 12 Monate</li>
          </ul>

          <h3>5.2 Kündigung</h3>
          <ul>
            <li>Kündigung jederzeit per E-Mail an info@interlingua.app</li>
            <li><strong>Kündigungsfrist:</strong> Zum Ende der aktuellen Abrechnungsperiode</li>
            <li>Nach Kündigung: Wechsel zur kostenlosen Basis-Version</li>
          </ul>

          <div className="bg-amber-50 p-4 rounded-lg my-6">
            <h2 className="text-amber-800 flex items-center mb-3">
              <Clock className="w-5 h-5 mr-2" />
              Widerrufsrecht für Verbraucher
            </h2>
            
            <h3 className="text-amber-800">Widerrufsbelehrung</h3>
            <p className="text-amber-700">
              <strong>Widerrufsfrist:</strong> Sie haben das Recht, binnen vierzehn Tagen ohne Angabe 
              von Gründen diesen Vertrag zu widerrufen.
            </p>
            
            <p className="text-amber-700">
              Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses 
              (bei Premium-Abonnements ab Zahlungsbestätigung).
            </p>

            <h4 className="text-amber-800">Widerrufsfolgen</h4>
            <p className="text-amber-700 text-sm">
              Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von 
              Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag 
              zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns 
              eingegangen ist.
            </p>
          </div>

          <h2>6. Pflichten des Nutzers</h2>
          <ul>
            <li><strong>Wahrheitsgemäße Angaben</strong> bei der Registrierung</li>
            <li><strong>Schutz der Zugangsdaten</strong> - keine Weitergabe an Dritte</li>
            <li><strong>Ordnungsgemäße Nutzung</strong> - keine missbräuchliche Verwendung</li>
            <li><strong>Respektvoller Umgang</strong> mit anderen Nutzern und dem System</li>
            <li><strong>Einhaltung geltender Gesetze</strong> bei der Nutzung</li>
          </ul>

          <h2>7. Verfügbarkeit und technische Anforderungen</h2>
          <h3>7.1 Verfügbarkeit</h3>
          <p>
            Wir bemühen uns um eine hohe Verfügbarkeit der Plattform (Ziel: 99% Uptime). 
            Wartungsarbeiten werden nach Möglichkeit außerhalb der Hauptnutzungszeiten durchgeführt.
          </p>

          <h3>7.2 Technische Anforderungen</h3>
          <ul>
            <li>Moderner Webbrowser mit JavaScript-Unterstützung</li>
            <li>Internetverbindung für Online-Features</li>
            <li>Mikrofon für Aussprache-Training (empfohlen)</li>
            <li>Lautsprecher/Kopfhörer für Audio-Feedback</li>
          </ul>

          <h2>8. Datenschutz und Datenverwendung</h2>
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns wichtig. Einzelheiten zur Erhebung, 
            Verarbeitung und Nutzung Ihrer Daten finden Sie in unserer 
            <Link to="/datenschutz" className="text-emerald-600 hover:text-emerald-700">
              Datenschutzerklärung
            </Link>.
          </p>

          <h2>9. Haftung und Gewährleistung</h2>
          <h3>9.1 Haftungsbeschränkung</h3>
          <p>
            Wir haften nur bei Vorsatz und grober Fahrlässigkeit. Die Haftung für leichte 
            Fahrlässigkeit ist auf die Verletzung wesentlicher Vertragspflichten beschränkt.
          </p>

          <h3>9.2 Lernziele</h3>
          <p>
            <strong>Wichtiger Hinweis:</strong> INTERLINGUA.APP ist ein Lernwerkzeug. Der Lernerfolg 
            hängt von individuellen Faktoren ab. Wir garantieren keine spezifischen Lernergebnisse.
          </p>

          <h2>10. Änderungen der AGB</h2>
          <p>
            Wir behalten uns vor, diese AGB zu ändern. Änderungen werden per E-Mail mitgeteilt 
            und gelten als genehmigt, wenn Sie nicht binnen eines Monats widersprechen.
          </p>

          <h2>11. Schlussbestimmungen</h2>
          <h3>11.1 Anwendbares Recht</h3>
          <p>
            Es gilt schweizerisches Recht unter Ausschluss des UN-Kaufrechts.
          </p>

          <h3>11.2 Gerichtsstand</h3>
          <p>
            Gerichtsstand für alle Streitigkeiten ist Luzern, Schweiz.
          </p>

          <h3>11.3 Salvatorische Klausel</h3>
          <p>
            Sollten einzelne Bestimmungen dieser AGB unwirksam sein, berührt dies die 
            Wirksamkeit der übrigen Bestimmungen nicht.
          </p>

          <div className="border-t pt-6 mt-8 text-sm text-gray-500">
            <p><strong>Stand:</strong> {new Date().toLocaleDateString('de-DE')}</p>
            <p className="mt-2">
              <strong>Kontakt für Fragen:</strong> info@interlingua.app<br />
              MYSYMP AG, CH-6207 Nottwil, Schweiz
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AGB;